import { jsx as _jsx } from "react/jsx-runtime";
import GoogleIcon from "@mui/icons-material/Google";
import { Button } from "@mui/material";
export var GoogleButton = function (_a) {
    var text = _a.text, onClick = _a.onClick;
    return (_jsx(Button, { variant: "outlined", startIcon: _jsx(GoogleIcon, {}), onClick: onClick, children: text }));
};
